import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-costcenters',
  templateUrl: './costcenters.component.html',
  styleUrls: ['./costcenters.component.css']
})
export class CostCentersComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
